export const BASE_DADATA_URL = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/";
export const API_DADATA_KEY = "e222d1ecd790a3ca7738f534711c2b4c28b91afa";
export const TOKEN = "token";
export const REGION_ID = "regionId";
export const DISTRICT_ID = "districtId";
export const CITY_ID = "cityId";
export const STREET_ID = "streetId";
export const BUILDING_ID = "buildingId";
export const QUERY = "query";
export const CONTENT_TYPE = "contentType";
export const WITH_PARENT = "withParent";

export const LIMIT = "limit";
export const OFFSET = "offset";
export const TYPE_CODE = "typeCode";
export const ZIP = "zip";
export const ONE_STRING = "oneString";
export const CALLBACK = "callback";
